export default __webpack_public_path__ + "static/media/Accenture.83e2c6b4.png";